// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-name {
  margin: 2px 0;
  font-family: AppFont;
  font-size: 12px;
  line-height: 16.55px;
  text-align: left;
}

h4 {
  display: flex;
  flex: 1;
}

.order-item {
  padding: 12px;
  margin-bottom: 17px;
  background: #ffffff;
  border-radius: var(--radius-default);
  box-shadow: 0px 0px 15px 0px rgba(125, 93, 40, 0.1019607843);
  border: 1px solid #939393;
}

.order-image {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  position: relative;
  padding-top: 100%;
  background: var(--ion-color-secondary-tint);
}
.order-image > ion-img {
  position: absolute;
  top: 8px;
  left: 8px;
  bottom: 8px;
  right: 8px;
}

.adds-price {
  margin-left: 5px;
  color: var(--ion-color-label);
}

ion-fab-button {
  --box-shadow: none;
}

.order-qty {
  margin: 10px 0;
}

.note {
  margin: 5px;
  font-size: small;
}

.qty__btn {
  width: 30px;
  height: 30px;
  margin: 0;
}
.qty__btn button {
  box-shadow: unset;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
}

.price {
  margin-left: 10px;
}

.qty {
  margin: 0 15px;
  font-size: 14px;
  color: #333333;
}

.article-price {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 21.6px;
  letter-spacing: 0.07em;
  text-align: right;
  color: #1E1E1C;
  white-space: nowrap;
}

ion-icon {
  height: 32px;
  width: 32px;
  cursor: pointer;
  color: var(--randy-gray);
}
ion-icon:hover {
  opacity: 0.7;
}

app-quantity-selector {
  --quantity-selector-height: 30px;
  --quantity-selector-border-width: 0px;
  --quantity-selector-border-color: #785526;
  --quantity-selector-background: #785526;
  --quantity-selector-text-color: #fff;
}

.order-article-name {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 21.6px;
  text-align: left;
  color: #1E1E1C;
}

.order-article-description {
  font-family: AppFont;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #666666;
  margin-bottom: 8px;
}

.option-quantity {
  font-size: 14px;
  color: var(--ion-color-label);
}

.pfand {
  font-size: 10px;
}

.header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 4px;
}

.name-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  padding-right: 12px;
}

.actions-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.actions-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.article-image {
  width: 51px;
  height: 46px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EAEA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAFD;;AAKA;EACC,aAAA;EACA,OAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,oCAAA;EACA,4DAAA;EACG,yBAAA;AAHJ;;AAMA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,2CAAA;AAHD;AAKC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAHF;;AAOA;EACC,gBAAA;EACA,6BAAA;AAJD;;AAOA;EACC,kBAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,WAAA;EAEA,gBAAA;AALD;;AAQA;EACC,WAAA;EACA,YAAA;EACA,SAAA;AALD;AAOC;EACC,iBAAA;AALF;AAQC;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AANF;;AAUA;EACC,iBAAA;AAPD;;AAUA;EACC,cAAA;EACA,eAAA;EACA,cAAA;AAPD;;AAUA;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAPD;;AAUA;EACC,YAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;AAPD;AASC;EACC,YAAA;AAPF;;AAWA;EACC,gCAAA;EACA,qCAAA;EACA,yCAAA;EACA,uCAAA;EACA,oCAAA;AARD;;AAWA;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AARD;;AAWA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AARD;;AAUA;EACC,eAAA;EACA,6BAAA;AAPD;;AASA;EACC,eAAA;AAND;;AASA;EACC,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;AAND;;AASA;EACC,aAAA;EACG,sBAAA;EACH,uBAAA;EACA,2BAAA;EACA,OAAA;EACA,mBAAA;AAND;;AASA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAND;;AASA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AAND;;AASA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AANF","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\n.option-name {\n\tmargin: 2px 0;\n\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 16.55px;\n\ttext-align: left;\n}\n\nh4 {\n\tdisplay: flex;\n\tflex: 1;\n}\n\n.order-item {\n\tpadding: 12px;\n\tmargin-bottom: 17px;\n\tbackground: #ffffff;\n\t// border: 0.6px solid #9caeb9;\n\tborder-radius: var(--radius-default);\n\tbox-shadow: 0px 0px 15px 0px #7D5D281A;\n    border: 1px solid #939393;\n}\n\n.order-image {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 5px;\n\tposition: relative;\n\tpadding-top: 100%;\n\tbackground: var(--ion-color-secondary-tint);\n\n\t> ion-img {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tleft: 8px;\n\t\tbottom: 8px;\n\t\tright: 8px;\n\t}\n}\n\n.adds-price {\n\tmargin-left: 5px;\n\tcolor: var(--ion-color-label);\n}\n\nion-fab-button {\n\t--box-shadow: none;\n}\n\n.order-qty {\n\tmargin: 10px 0;\n}\n\n.note {\n\tmargin: 5px;\n\n\tfont-size: small;\n}\n\n.qty__btn {\n\twidth: 30px;\n\theight: 30px;\n\tmargin: 0;\n\n\tbutton {\n\t\tbox-shadow: unset;\n\t}\n\n\tspan {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tleft: 0;\n\t\tright: 0;\n\t\tmargin: auto;\n\t}\n}\n\n.price {\n\tmargin-left: 10px;\n}\n\n.qty {\n\tmargin: 0 15px;\n\tfont-size: 14px;\n\tcolor: #333333;\n}\n\n.article-price {\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 21.6px;\n\tletter-spacing: 0.07em;\n\ttext-align: right;\n\tcolor: #1E1E1C;\n\twhite-space: nowrap;\n}\n\nion-icon {\n\theight: 32px;\n\twidth: 32px;\n\tcursor: pointer;\n\tcolor: var(--randy-gray);\n\t\n\t&:hover {\n\t\topacity: 0.7;\n\t}\n}\n\napp-quantity-selector {\n\t--quantity-selector-height: 30px;\n\t--quantity-selector-border-width: 0px;\n\t--quantity-selector-border-color: #785526;\n\t--quantity-selector-background: #785526;\n\t--quantity-selector-text-color: #fff;\n}\n\n.order-article-name {\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 21.6px;\n\ttext-align: left;\n\tcolor: #1E1E1C;\n}\n\n.order-article-description {\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tline-height: 16px;\n\tcolor: #666666;\n\tmargin-bottom: 8px;\n}\n.option-quantity {\n\tfont-size: 14px;\n\tcolor: var(--ion-color-label);\n}\n.pfand {\n\tfont-size: 10px;\n}\n\n.header-row {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tmargin-bottom: 4px;\n}\n\n.name-col {\n\tdisplay: flex;\n    flex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex: 1;\n\tpadding-right: 12px;\n}\n\n.actions-row {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-top: 8px;\n}\n\n.actions-col {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tgap: 8px;\n}\n\n.article-image {\n  width: 51px;\n  height: 46px;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
